export const mapConfig = {
    token: process.env.REACT_APP_MAPBOX_TOKEN,
    defaultZoom: 4,
    defaultMovingMethod: "flyTo",
    defaultCenter: [6.087814, 49.770628],
    defaultProjection: "mercator",
  };
  